import React, {useState} from 'react'
import {updateTax, getTaxById} from "../../services/serviceTax";
import {Button, Form, Input, Modal, InputNumber} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {TextArea} = Input

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const TaxEdit = ({tax, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleEditClick = () => {
        getTaxById(tax.id)
            .then(({data}) => {
                form.setFieldsValue({
                    taxName: data.name,
                    taxCode: data.code,
                    taxDescription: data.description,
                    taxRatio: data.ratio
                })
            })
        setEditModal(!editModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let request = {
            name: list.taxName,
            code: list.taxCode,
            ratio: list.taxRatio,
            description: list.taxDescription,
            id: tax.id
        }
        updateTax(request)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Button type={'link'} onClick={() => handleEditClick()}>Güncelle</Button>

            <Modal
                open={editModal}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={() => form.submit()}>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item
                        label={'Vergi Adı'}
                        name={'taxName'}
                        rules={[
                            {required: true, message:'Vergi Adı Alanı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Vergi Adı Alanı En Az 5 En Fazla 300 Karakter Olmalıdır'}
                        ]}

                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Kodu'}
                        name={'taxCode'}
                        rules={[
                            {required: true, message:'Vergi Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Vergi Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Vergi Kodu Alanı En Az 3 En Fazla 20 Karakter Olmalıdır'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Açıklaması'}
                        name={'taxDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Oranı'}
                        name={'taxRatio'}
                        rules={[
                            {required: true, message: 'Vergi Oranı Alanı Boş Bırakılamaz'},
                            {type: 'number', min: 1.00, max: 1000.00, message: 'Vergi Oranı En az 1 En Fazla 1000 Olabilir'}
                        ]}
                    >
                        <InputNumber min={0} step={0.1}/>
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default TaxEdit